import client from '../../client';

const subaccountResendRequest = async (
  userId: string,
  resetUrl: string
): Promise<void> => {
  const { data } = await client.get<void>('/subaccount/invite/resend', {
    params: {
      domain: process.env.NEXT_PUBLIC_DOMAIN,
      resetUrl,
      userId,
    },
  });

  return data;
};

export default subaccountResendRequest;
